import { log } from "./logger";
// Copy text to clipboard
export const copyToClipboard = async (text: string) => {
    try {
        await navigator.clipboard.writeText(text);
        log("Copied to clipboard:", text);
    } catch (err) {
        log("Failed to copy!", err);
    }
};
